export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./welcome.vue?vue&type=template&id=d7a0d1c4&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bonuses/welcome.vue?vue&type=template&id=d7a0d1c4&scoped=true
// module id = Ah7y
// module chunks = 0